/**
 * App-wide typography (chat style guide + Material scale).
 * Weights: 300 light, 400 regular, 500 medium, 600 semibold (headers / emphasis), 700 bold (hero titles).
 */
export const appTypography = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  allVariants: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  /** Primary operational / hero titles (bold) */
  h5: {
    fontSize: '1.375rem',
    fontWeight: 700,
    lineHeight: 1.334,
    letterSpacing: '0em'
  },
  /** Main section headers (e.g. app bar), 20px */
  h6: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: '0.0075em'
  },
  /** Chat group names in header — 16px */
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.75,
    letterSpacing: '0.00938em'
  },
  /** Chat list titles — 14px, medium */
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.57,
    letterSpacing: '0.00714em'
  },
  /** Regular body — 16px */
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.00938em'
  },
  /** Message content — 14px */
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: '0.01071em'
  },
  /** Timestamps, helper text — 12px */
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: '0.03333em'
  },
  button: {
    fontWeight: 500,
    textTransform: 'none'
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 2.66,
    letterSpacing: '0.08333em',
    textTransform: 'uppercase'
  }
}
